// 消息
export default {
    noNews: '暂无消息',
    TINO: '没有更多了',
    historicalNews: '历史消息',
    time: '时间'
}